<template>
  <v-container class="joukkueet-page">
    <div class="d-flex align-center flex-wrap mt-2">
      <v-select
        v-model="seasonId"
        :items="unarchived_seasons"
        :loading="loading_seasons"
        class="joukkueet-control"
        style="max-width: 220px;"
        dense
        hide-details
        item-text="season_name"
        item-value="id"
        label="Kausi"
      />

      <ChooseClubSelect
        v-if="currentTeam"
        v-model="leagueClubId"
        class="ml-4 joukkueet-control"
        width="280px"
      />
    </div>

    <MostCommonRosterBox
      :league-id="leagueId"
      :league-club-id="leagueClubId"
      :season-id="seasonId"
    />

    <OutfieldFilterShortcutBox
      :league-id="leagueId"
      :league-club-id="leagueClubId"
      :season-id="seasonId"
    />

    <v-row class="mt-1" dense>
      <v-col cols="12" md="6">
        <OutfieldFormationPieBox
          :league-id="leagueId"
          :league-club-id="leagueClubId"
          :season-id="seasonId"
          bases-state="Ajo"
          hitter-side="R"
          title="Ajotilanteen ulkopelikuvio oikealta lyövälle"
        />
      </v-col>
      <v-col cols="12" md="6">
        <OutfieldFormationPieBox
          :league-id="leagueId"
          :league-club-id="leagueClubId"
          :season-id="seasonId"
          bases-state="Ajo"
          hitter-side="L"
          title="Ajotilanteen ulkopelikuvio vasemmalta lyövälle"
        />
      </v-col>
    </v-row>

    <v-row class="mt-1" dense>
      <v-col cols="12" md="6">
        <TopRunnersBox
          :league-id="leagueId"
          :league-club-id="leagueClubId"
          :season-id="seasonId"
        />
      </v-col>
      <v-col cols="12" md="6">
        <TopMadeOutsBox
          :league-id="leagueId"
          :league-club-id="leagueClubId"
          :season-id="seasonId"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ChooseClubSelect from '@/components/games/ChooseClubSelect.vue'
import MostCommonRosterBox from '@/components/joukkueet/MostCommonRosterBox.vue'
import OutfieldFilterShortcutBox from '@/components/joukkueet/OutfieldFilterShortcutBox.vue'
import OutfieldFormationPieBox from '@/components/joukkueet/OutfieldFormationPieBox.vue'
import TopRunnersBox from '@/components/joukkueet/TopRunnersBox.vue'
import TopMadeOutsBox from '@/components/joukkueet/TopMadeOutsBox.vue'

export default {
  name: 'Joukkueet',
  components: {
    ChooseClubSelect,
    MostCommonRosterBox,
    OutfieldFilterShortcutBox,
    OutfieldFormationPieBox,
    TopRunnersBox,
    TopMadeOutsBox
  },
  data: () => ({
    leagueClubId: null,
    seasonId: null
  }),
  mounted() {
    if(this.$route.query.club_id) {
      this.leagueClubId = parseInt(this.$route.query.club_id)
    }

    this.initSeasons(this.leagueId)
      .then(seasons => {
        const querySeasonId = this.$route.query.season_id ? parseInt(this.$route.query.season_id) : null
        this.seasonId = querySeasonId || seasons.find(season => !season.archived)?.id || seasons[0]?.id || null
        this.syncQuery()
      })
  },
  watch: {
    seasonId() {
      this.syncQuery()
    },
    leagueClubId() {
      this.syncQuery()
    }
  },
  computed: {
    ...mapGetters('admin', [
      'loading_seasons',
      'unarchived_seasons'
    ]),
    ...mapGetters('user', [
      'currentTeam',
      'leagueId'
    ])
  },
  methods: {
    ...mapActions('admin', [
      'initSeasons'
    ]),
    syncQuery() {
      const query = {}
      if(this.seasonId) query.season_id = String(this.seasonId)
      if(this.leagueClubId) query.club_id = String(this.leagueClubId)

      if(
        query.season_id === this.$route.query.season_id &&
        query.club_id === this.$route.query.club_id
      ) return

      this.$router.replace({ query }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.joukkueet-page {
  max-width: 1200px;
  min-height: 500px;
  padding-bottom: 100px;
}

.joukkueet-control {
  max-width: 100%;
}
</style>
